// src/state/menu/types/specials_types.ts
var ESpecialApplyTypes = /* @__PURE__ */ ((ESpecialApplyTypes2) => {
  ESpecialApplyTypes2["ITEM"] = "item";
  ESpecialApplyTypes2["ORDER"] = "order";
  ESpecialApplyTypes2["BOGO"] = "bogo";
  return ESpecialApplyTypes2;
})(ESpecialApplyTypes || {});

export { ESpecialApplyTypes };
